let browser
if (process.env.APP_TARGET == 'extension')
    browser = require('webextension-polyfill')

const KEY = 'deals_enabled'

//kill switch: users can deactivate the whole deals module;
//default on while LTDHunt is the public product direction
export async function dealsEnabled() {
    try {
        const res = await browser.storage.local.get(KEY)
        return res[KEY] !== false
    } catch(e) {
        return true
    }
}

export async function setDealsEnabled(on) {
    try {
        await browser.storage.local.set({ [KEY]: !!on })
    } catch(e) {}
}
